import { render } from "./StockReportPage.vue?vue&type=template&id=31636bfe&scoped=true&ts=true"
import script from "./StockReportPage.vue?vue&type=script&lang=ts"
export * from "./StockReportPage.vue?vue&type=script&lang=ts"

import "./StockReportPage.vue?vue&type=style&index=0&id=31636bfe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31636bfe"]])

export default __exports__